export default __webpack_public_path__ + "static/media/fontRoboto400_greek.c35e4c39.woff2";